export enum Permission {
  HACKER = "hacker",
  VOLUNTEER = "volunteer",
  VIEW_FULL_SCHEDULE = "view-full-schedule",

  SPONSOR = "sponsor",
  SPONSOR_RECRUITMENT_ACCESS = "sponsor-recruitment-access",
  SPONSOR_SHIPPED_SWAG_ACCESS = "sponsor-shipped-swag-access",

  GENERAL = "general",

  HACKER_RSVP = "hacker-rsvp",
  HACKER_RSVP_NOT_RESTRICTED = "hacker-rsvp-not-restricted",
  RSVP = "rsvp",
  RSVP_EDIT = "rsvp-edit",
  RSVP_FORM = "rsvp-form",
  TRAVEL_PLAN_FORM = "travel-plan-form",
  TICKET_ACCESS = "ticket-access",

  ATTENDEE_EVENT_ACCESS = "attendee-event-access",
  HACKER_EVENT_ACCESS = "hacker-event-access",
  MENTOR_EVENT_ACCESS = "mentor-event-access",
  SPONSOR_EVENT_ACCESS = "sponsor-event-access",
  WORKSHOP_LEAD_EVENT_ACCESS = "workshop-lead-event-access",
  VOLUNTEER_EVENT_ACCESS = "volunteer-event-access",

  MENTOR = "mentor",

  WORKSHOP_LEAD = "workshop_lead",
  JUDGE = "judge",

  STAGING = "staging",

  ORGANIZER = "organizer",
}
